import { ChangeDetectionStrategy, Component, HostBinding, Input, inject } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { SurveyStore } from '@player/shared/services/survey-store.service';
import { NgClass } from '@angular/common';

@Component({
  selector: 'brand-menu',
  standalone: true,
  templateUrl: './brand-menu.component.html',
  styleUrls: ['./brand-menu.component.scss'],
  imports: [MatIconModule, NgClass],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BrandMenu {
  readonly ss = inject(SurveyStore);

  @Input()
  @HostBinding('class')
  class: string;

  isEsko = this.ss.branding.value?.name === 'Esko';
}
